import { render, staticRenderFns } from "./ChangeLogsForm.vue?vue&type=template&id=6872ff41&"
import script from "./ChangeLogsForm.vue?vue&type=script&lang=js&"
export * from "./ChangeLogsForm.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLogsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports